export const globalScripts = () => {};
export const globalStyles = "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');";
